import { AfterViewInit, Component, ElementRef, OnDestroy, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { TabsComponent } from '@vg-constellation/angular-16/tabs';
import { Subscription } from 'rxjs';
import { AdobeLaunchService } from 'src/app/shared/services/adobe-launch.service';
import { ModalService } from 'src/app/shared/services/modal.service';
import { GradeMaterials } from 'src/app/shared/models/grade-materials.model';
import { GRADES_9_10_MATERIALS } from '../materials/9-10.materials';

@Component({
  selector: 'grades9-10',
  templateUrl: './grades9-10.component.html',
  styleUrls: ['./grades9-10.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class Grades910Component implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('jobsTabs') jobsTabs: TabsComponent;
  @ViewChild('jobAssignmentTabs') jobAssignmentTabs: TabsComponent;
  @ViewChild('investingTabs') investingTabs: TabsComponent;
  @ViewChild('insuranceTabs') insuranceTabs: TabsComponent;
  private langChangeSubscription!: Subscription;
  grades910Materials: GradeMaterials = GRADES_9_10_MATERIALS;

  @ViewChild('howWork') howWork!: ElementRef;
  @ViewChild('curStand') curStand!: ElementRef;
  @ViewChild('proOut') proOut!: ElementRef;
  @ViewChild('econSys') econSys!: ElementRef;
  @ViewChild('investing') investing!: ElementRef;
  @ViewChild('insurance') insurance!: ElementRef;
  @ViewChild('prepMat') prepMat!: ElementRef;
  @ViewChild('rewards') rewards!: ElementRef;
  @ViewChild('advMod') advMod!: ElementRef;
  @ViewChild('firstDay') firstDay!: ElementRef;
  @ViewChild('secondDay') secondDay!: ElementRef;
  @ViewChild('everyDay') everyDay!: ElementRef;
  @ViewChild('actJobs') actJobs!: ElementRef;
  @ViewChild('syllabusDay') syllabusDay!: ElementRef;
  @ViewChild('paydayAuction') paydayAuction!: ElementRef;
  @ViewChild('actBill') actBill!: ElementRef;
  @ViewChild('actTax') actTax!: ElementRef;
  @ViewChild('yearEnd') yearEnd!: ElementRef;
  @ViewChild('classMaterials') classMaterialsSection!: ElementRef;
  
  constructor(
    public modalService: ModalService,
    private readonly adobeLaunchService: AdobeLaunchService,
    private translateService: TranslateService
  ) { }

  ngOnInit(): void {
    this.adobeLaunchService.trackPageView({
      pageTitle:'Grades 9 to 10'
    });
    
    this.langChangeSubscription = this.translateService.onLangChange.subscribe((_: LangChangeEvent) => {
      this.updateTabLabels();
    });
  }

  ngAfterViewInit(): void {
    this.updateTabLabels();
  }

  private updateTabLabels(): void {
    [this.jobsTabs, this.jobAssignmentTabs, this.investingTabs, this.insuranceTabs]
      .forEach(tabComponent => {
        tabComponent?.menuData?.items?.forEach(tab => {
          tab.labelText = this.translateService.instant('grades.table.header.' + (tab.tabPanelId || ''));
        });
      });
  }

  ngOnDestroy(): void {
    if (this.langChangeSubscription) {
      this.langChangeSubscription.unsubscribe();
    }
  }

  onSidebarNavClick(elementName: string): void {
    const sectionMap: { [key: string]: ElementRef } = {
      howWork: this.howWork,
      curStand: this.curStand,
      proOut: this.proOut,
      econSys: this.econSys,
      investing: this.investing,
      insurance: this.insurance,
      prepMat: this.prepMat,
      rewards: this.rewards,
      advMod: this.advMod,
      firstDay: this.firstDay,
      secondDay: this.secondDay,
      everyDay: this.everyDay,
      actJobs: this.actJobs,
      syllabusDay: this.syllabusDay,
      paydayAuction: this.paydayAuction,
      actBill: this.actBill,
      actTax: this.actTax,
      yearEnd: this.yearEnd,
      classMaterials: this.classMaterialsSection,
    };

    const targetSection = sectionMap[elementName];
    if (targetSection) {
      setTimeout(() => {
        targetSection.nativeElement.focus({ preventScroll: true });
      }, 0);
    }
  }
}
